<template>
  <div class="page-content conmon-top">
    <div class="top-nav">
      <div @click="tj = 1" :class="{'choosed' : tj == 1}">模板市场</div>
      <div @click="tj = 2" :class="{'choosed' : tj == 2}">我的模板</div>
    </div>
    <div class="clear"></div>
    <!-- 中奖统计 -->
    <div v-show="tj===2">
      <template-prize></template-prize>
    </div>
    <!--扫码统计-->
    <div v-show="tj===1">
      <div class="content">
        <div v-for="item in templateList" :key="item.id" class="templateList" @click="addAcivitys(item.id)">
          <img :src="item.picture" class="tem_img">
          <p>{{item.name}}</p>
          <div class="add_btn" @click="addAcivitys(item.id)">
            创建活动
          </div>
        </div>
        <div class="templateList" style="background:#E7E7E7">
          <img src="../../assets/images/expectMore.png" style="width: 68px;height: 68px;margin: 41px auto;">
          <p>期待更多</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPrizeStatics, getActivitysStatics, exportActivitys, getDrawcodeStatics, exportDrawcodeStatic } from '@/api/activity.js'
import templatePrize from '@/components/prize/template-prize.vue'
import { getTemplate } from '@/api/activity.js'
export default {
  name: 'newGuessRiddlesStatistics',
  data () {
    return {
      templateList: [],
      tj: 1, //1中奖统计，2扫码统计
      formInlineTmp: {},
      drawTypes: [
        {
          label: '主奖池',
          value: 1
        },
        {
          label: '助力奖池',
          value: 2
        }
      ],
      prizelevel: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '一等奖',
          value: 1
        },
        {
          label: '二等奖',
          value: 2
        },
        {
          label: '三等奖',
          value: 3
        },
        {
          label: '四等奖',
          value: 4
        },
        {
          label: '五等奖',
          value: 5
        },
        {
          label: '六等奖',
          value: 6
        }
      ],
      drawStatus: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '已中奖',
          value: 1
        },
        {
          label: '未中奖',
          value: -1
        }
      ],
      activityID: '',
      formInline: {
        prize_level: '',
        startdate: '',
        enddate: '',
        type: 1
      },
      drawformInline: {
        draw_status: '',
        startdate: '',
        enddate: '',
      },
      type:1, //1主奖池，2助力奖池
      hide: true,
      loading: true,
      tableData: [],//列表数据
      page: 1,
      limit: 10,
      totalCount: 0,
      paginationShow: true,
      prizetotal: 0,//奖品总数
      winNum: 0,//已中奖数
      leaveNum: 0,//剩余奖品数
      prizeStatic:[],//每种奖品统计数据
      drawtotalCount: 0,
      drawtableData: [],//列表数据
      page_draw: 1,
      paginationShow_draw: true,
      loading_draw: true,
    }
  },
  methods: {
    getTemplate() {
      let data = {
        page: 1,
        limit: 10
      }
      getTemplate(data).then(res => {
        if (res.data.code === 0) {
          console.log(res.data)
          this.templateList = res.data.data.list
          this.templateList = [
            {
              picture: require('../../assets/images/Bitmap3.png'),
              name: '砸酒坛中大奖',
            },
            {
              picture: require('../../assets/images/Bitmap1.png'),
              name: '幸运大转盘',
            },
            {
              picture: require('../../assets/images/Bitmap2.png'),
              name: '欢乐刮刮卡',
            },
            {
              picture: require('../../assets/images/Bitmap4.png'),
              name: '摇一摇送大奖',
            },
            {
              picture: require('../../assets/images/Bitmap5.png'),
              name: '砸金蛋赢大奖',
            },
            {
              picture: require('../../assets/images/Bitmap6.png'),
              name: '扫码开宝箱',
            },
            {
              picture: require('../../assets/images/Bitmap7.png'),
              name: '欢乐娃娃机',
            }
          ]
          console.log('this.templateList', this.templateList)
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    addAcivitys(id) {
      this.$router.push({name: 'templateDetails', query: { template_id: id }})
    },
    searchData() {
      this.page = 1
      //this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.getData()
    },
    searchData_draw() {
      this.page_draw = 1
      this.getData_draw()
    },
    typeChange(v){
      this.formInline.type = v
      this.type = v
      this.page = 1
      this.getData()
      this.getPrizeData()
    },
    drawStatusChange() {
      // this.page = 1
      // this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      // this.getData()
    },
    exportAction() {
      this.activityID = this.$route.query.id
      exportActivitys(this.activityID, this.formInline).then(res => {
        this.download(res)
      })
    },
    exportAction_draw(){
      this.activityID = this.$route.query.id
      exportDrawcodeStatic(this.activityID, this.drawformInline).then(res => {
        this.download(res)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    handleSizeChange(val) {
      this.limit = val
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    handleSizeChange_draw(val) {
      this.limit = val
    },
    handleCurrentChange_draw(page) {
      this.page_draw = page
      this.getData_draw()
    },
    getData() {
      this.paginationShow = false
      this.loading = true
      getActivitysStatics(this.$route.query.id, this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.totalCount = res.data.data.total
          this.paginationShow = true
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    getData_draw() {
      this.paginationShow_draw = false
      this.loading_draw = true
      getDrawcodeStatics(this.$route.query.id, this.page_draw, this.drawformInline).then(res => {
        if (res.data.code === 0) {
          this.drawtableData = res.data.data.list
          this.drawtotalCount = res.data.data.total
          this.paginationShow_draw = true
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading_draw()
    },
    getPrizeData() {
      this.loading = true
      getPrizeStatics(this.$route.query.id, this.type).then(res => {
        if (res.data.code === 0) {
          this.prizetotal = res.data.prizetotal,
          this.winNum = res.data.winNum,
          this.leaveNum = res.data.leaveNum,
          this.prizeStatic = res.data.data
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    openLoading_draw() {
      setTimeout(() => {
        this.loading_draw = false
      }, 500)
    }
  },
  created() {
    this.activityID = this.$route.query.id
    this.getData()
    this.getPrizeData()
    this.getData_draw()
    this.getTemplate()
  },
  components: {
    'template-prize': templatePrize
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}

.tj_prize{
  color: #333;height: auto; background: #fff; line-height: 30px; font-size: 14px; margin-top: 24px; padding:10px 20px 10px 32px; text-align: left;
}
.prizelist{
  color: #606266;
}
.left{float:left;}
.right{float:left;}
.clear{clear: both;}
.w100{width: 100px;}
.w150{width: 150px;}
.tabdiv{ padding: 0px; font-size: 15px;  margin-bottom: 20px;}
.tabdiv div{ cursor: pointer; }
.activetab{
  border-width: 2px;
  border-style: solid;
  border-color: #1890FF;
  border-left: 0px;
  border-top: 0px;
  border-right: 0px;
  border-radius: 0px;
  padding: 5px;
}

.headimg img,.headimg span{vertical-align:middle; }
.headimg img {width: 30px;height: 30px;border-radius: 20px;margin-right: 10px; }

.top-nav{
  width: calc(100% - 40px);
  margin: 0 auto 0;
  border-bottom: 1px solid #dedede;
  height: 50px;
}
.top-nav div{
  float: left;
  height: 50px;
  line-height: 50px;
  width: 75px;
  font-size: 14px;
  cursor: pointer;
}
.choosed{
  border-bottom: 1px solid #1980FF;
}
.content{
    min-height: 590px;
    background: #fff;
    margin: 24px;
    margin-bottom: 0;
  }
  .templateList{
    display: inline-block;
    width: 300px;
    height: 150px;
    float: left;
    margin: 20px;
    /*border: 1px solid #b3b0b0;*/
    background: #fff;
    /*border-radius: 5px;*/
    position: relative;
    cursor: pointer;
  }
  .templateList p{
    margin: 10px 0;
  }
  .templateList:hover .add_btn{
    display: block;
  }
  .tem_img{
    width: 100%;
    height: 100%;
  }
  .add_btn{
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    background: rgba(5, 5, 5, 0.52);
    cursor: pointer;
    display: none;
    line-height: 40px;
    color: #fff;
  }
</style>
